import React from 'react'; 
import { Button, ButtonProps } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { colors } from '../../styles/colors';


interface IconButtonProps extends ButtonProps {
    icon: React.ReactNode;
    iconColor?: string; 
    borderColor?: string; 
    hoverBackground?: string; 
}

const IconButton: React.FC<IconButtonProps> = ({
    icon,
    onClick, // keep onClick here
    disabled,
    iconColor,
    borderColor,
    hoverBackground,
    ...rest
}) => (
    <Button
        type="button"
        sx={{
            backgroundColor: 'white',
            border: '2px solid',
            borderColor: borderColor || colors.primary, 
            color: iconColor || colors.primary, 
            px: 0,
            py: 0,
            minWidth: 40,
            height: 40,
            borderRadius: '30%',
            transition: 'transform 0.3s ease-in-out',
            transform: 'scale(1)',
            '&:hover': {
                transform: 'scale(1.05)',
                background: hoverBackground || `linear-gradient(to bottom, ${colors.secondary}, ${colors.primary})`,
                color: 'white',
                border: 0,
            },
            '&:focus': {
                outline: 'none',
            },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        onClick={onClick}
        disabled={disabled}
        {...rest}
    >
        {icon}
    </Button>
);


export const SearchButton = (props: ButtonProps) => (
    <IconButton icon={<SearchIcon />} {...props} />
);

export const ClearButton = (props: ButtonProps) => (
    <IconButton
        icon={<ClearIcon />}
        iconColor="red"
        borderColor="red"
        hoverBackground="red"
        {...props}
    />
);



export default IconButton;
